import { OnInit } from '@angular/core';
import { MatDialog, MatSnackBar, MatDialogRef, MatChipInputEvent } from '@angular/material';
import { COPQMDR } from '../../../models/copq__mdr';
import { TranslateService } from '@ngx-translate/core';
import { PriceObservable } from '../../../services/price.service';
import { MdrService } from '../../../providers/mdr.service';
import { MdrObservable } from '../../../services/mdr.service';
import { ActivatedRoute } from '@angular/router';
import { MDR, MDR_STATUS } from '../../../models/mdr';
import { CostAvoidanceMDR } from '../../../models/costAvoidance__mdr';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ExcelService } from '../../../misc/export-xlsx/export-xlsx';
import * as XLSX from 'xlsx';
import { User } from '../../../models/user';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
var TaxComponent = /** @class */ (function () {
    function TaxComponent(translate, snackBar, priceObservable, mdrService, mdrObservable, aRoute, excel, dpipe, cpipe, dialog) {
        this.translate = translate;
        this.snackBar = snackBar;
        this.priceObservable = priceObservable;
        this.mdrService = mdrService;
        this.mdrObservable = mdrObservable;
        this.aRoute = aRoute;
        this.excel = excel;
        this.dpipe = dpipe;
        this.cpipe = cpipe;
        this.dialog = dialog;
        this.statusContainer = false;
        this.mdr = new MDR;
        this.sumCOPQ = 0;
        this.sumAvoid = 0;
        this.sumUOC = 0;
        this.sumTotal = 0;
        this.showAll = false;
        this.COPQs = [];
        this.costAvoidances = [];
        this.UOCs = [];
        this.uoc = [];
        this.copq = [];
        this.editing_freight = false;
        this.MDR_STATUS = MDR_STATUS;
        this.update = true;
        this.payment = {
            'tooltips': {
                'green': 'Pago Realizado',
                'yellow': 'Pago parcial realizado',
                'red': 'En espera de pago',
                'undefined': '',
            },
            'icons': {
                'green': 'fa-check',
                'yellow': 'fa-exclamation-triangle',
                'red': 'fa-exclamation-triangle',
                'undefined': '',
            },
            'classes': {
                'green': 'icon-green',
                'yellow': 'icon-yellow',
                'red': 'icon-red',
                'undefined': '',
            }
        };
        this.payField = {
            'color': 'undefined',
            'ov': []
        };
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.role = this.currentUser.user.role;
        this.user = this.currentUser.user.id;
    }
    TaxComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.priceObservable.currentPrice.subscribe(function (price) {
            if (price.sc !== null) {
            }
            _this.price = price;
            // console.log('Habemos Preço');
            // console.log(price);
        });
        this.mdrObservable.currentMDR.subscribe(function (mdr) {
            _this.mdr = mdr;
            _this.sumTotal = mdr.valorem + mdr.frete + mdr.additional;
            if (_this.sumTotal > 100000) {
                _this.sumTotal = 0;
            }
            // this.mdr.totalNF = Number(this.mdr.totalNF);
            _this.mdrService.getCoPQ(_this.mdr).subscribe(function (data) {
                _this.sumCOPQ = 0;
                data.forEach(function (elem) {
                    elem.value = Number(elem.value) / 100;
                    _this.sumCOPQ += elem.value;
                    elem.value = elem.value.toFixed(2);
                });
                _this.sumCOPQ = _this.sumCOPQ / 100;
                _this.COPQs = data;
            });
            _this.mdrService.getCostAvoidance(_this.mdr).subscribe(function (data) {
                _this.sumAvoid = 0;
                data.forEach(function (elem) {
                    _this.sumAvoid += Number(elem.value);
                });
                _this.costAvoidances = data;
            });
            _this.mdrService.getUOC(_this.mdr).subscribe(function (data) {
                _this.sumUOC = 0;
                data.forEach(function (elem) {
                    elem.value = Number(elem.value) / 100;
                    if (elem.status === true) {
                        _this.sumUOC += elem.value;
                    }
                    elem.value = elem.value.toFixed(2);
                });
                _this.sumUOC /= 100;
                _this.UOCs = data;
                _this.mdrService.getStatusPayment(_this.mdr.id).subscribe(function (payments) {
                    var frete_count = 0;
                    var frete_paid = 0;
                    var _loop_1 = function (i) {
                        if (payments[i].origem === 'FRETE') {
                            frete_count = frete_count + 1;
                            if (payments[i].status === 'PAID') {
                                frete_paid = frete_paid + 1;
                            }
                        }
                        else { // pra origem='UOC'
                            var uoc = _this.UOCs.find(function (u) { return (u.id === parseInt(payments[i].origemId, 10)); });
                            if (!uoc) {
                                // pagamento nao está presente na lista de pagamentos
                            }
                            else if (payments[i].status === 'PAID') {
                                uoc['color'] = 'green';
                            }
                            else if (payments[i].status === 'READY_TO_PAY') {
                                uoc['color'] = 'red';
                            }
                            else {
                                uoc['color'] = 'undefined';
                            }
                        }
                    };
                    // console.log({payments: payments});
                    // itera sobre os pagamentos
                    for (var i = 0; i < payments.length; i++) {
                        _loop_1(i);
                    }
                    if (frete_count === frete_paid) {
                        _this.payField.color = 'green';
                    }
                    else if (frete_paid === 0) {
                        _this.payField.color = 'red';
                    }
                    else {
                        _this.payField.color = 'yellow';
                    }
                });
            });
            _this.mdrService.getListUOC().subscribe(function (data) {
                _this.uoc = data;
            });
            _this.mdrService.getListCoPQ().subscribe(function (data) {
                _this.copq = data;
            });
        });
    };
    TaxComponent.prototype.editValues = function () {
        this.editing_freight = true;
    };
    TaxComponent.prototype.saveValues = function () {
        this.editing_freight = false;
        // save freight values
        this.savePrice();
        // save mdr.totalNF and mdr.totalKM
        this.saveMDR();
    };
    TaxComponent.prototype.saveMDR = function () {
        this.mdrService.update(this.mdr, this.user).subscribe(function (response) {
            // console.log(response);
        });
    };
    TaxComponent.prototype.sendApprovalRequest = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ChooseUsersDialogComponent, {
            width: '600px',
            data: {
                text: 'Deseja realmente aprovar o custo extra?',
            }
        });
        dialogRef.afterClosed().subscribe(function (response) {
            if (response[0] === true) {
                var users_1 = [];
                response[1].forEach(function (element) {
                    var user = new User();
                    user.email = element.value;
                    users_1.push(user);
                });
                _this.mdrService.sendApproveEmail(_this.mdr, users_1).subscribe(function (el) {
                    _this.snackBar.open('Email sent', 'Ok', {
                        duration: 4000,
                    });
                });
            }
        });
    };
    TaxComponent.prototype.approveUOC = function (uoc) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '600px',
            data: {
                text: 'Deseja realmente aprovar o custo extra?',
            }
        });
        dialogRef.afterClosed().subscribe(function (response) {
            if (response[0] === true) {
                _this.mdrService.removeOccurrence(uoc, true).subscribe(function (elem) {
                    _this.mdrService.getUOC(_this.mdr).subscribe(function (data) {
                        _this.snackBar.open('Custo Aprovado corretamente', 'Ok', {
                            duration: 4000,
                        });
                        _this.sumUOC = 0;
                        data.forEach(function (item) {
                            item.value = Number(item.value) / 100;
                            if (item.status === true) {
                                _this.sumUOC += item.value;
                            }
                            item.value = item.value.toFixed(2);
                        });
                        _this.sumUOC /= 100;
                        _this.UOCs = data;
                    });
                });
            }
        });
    };
    TaxComponent.prototype.removeUOC = function (uoc) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '600px',
            data: {
                text: 'Deseja realmente deletar o custo extra? Essa ação não pode ser desfeita.',
            }
        });
        dialogRef.afterClosed().subscribe(function (response) {
            if (response[0] === true) {
                _this.mdrService.removeOccurrence(uoc, false).subscribe(function (elem) {
                    _this.mdrService.getUOC(_this.mdr).subscribe(function (data) {
                        _this.snackBar.open('Custo deletado corretamente', 'Ok', {
                            duration: 4000,
                        });
                        _this.sumUOC = 0;
                        data.forEach(function (item) {
                            item.value = Number(item.value) / 100;
                            if (item.status === true) {
                                _this.sumUOC += item.value;
                            }
                            item.value = item.value.toFixed(2);
                        });
                        _this.sumUOC /= 100;
                        _this.UOCs = data;
                    });
                });
            }
        });
    };
    TaxComponent.prototype.removeCOPQ = function (copq) {
        var _this = this;
        // console.log(copq);
        var dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '600px',
            data: {
                text: '',
            }
        });
        dialogRef.afterClosed().subscribe(function (response) {
            if (response[0] === true) {
                _this.mdrService.removeOccurrenceCOPQ(copq).subscribe(function (elem) {
                    _this.mdrService.getCoPQ(_this.mdr).subscribe(function (data) {
                        _this.snackBar.open('Custo deletado corretamente', 'Ok', {
                            duration: 4000,
                        });
                        _this.sumCOPQ = 0;
                        data.forEach(function (item) {
                            item.value = Number(item.value) / 100;
                            _this.sumCOPQ += item.value;
                            item.value = item.value.toFixed(2);
                        });
                        _this.sumCOPQ /= 100;
                        _this.COPQs = data;
                    });
                });
            }
        });
    };
    TaxComponent.prototype.sanitizeInputMdr = function (field, value, tag) {
        var input = value.srcElement.value;
        this.update = false;
        input = input.replace('R$', '');
        input = input.replace(/ /g, '');
        input = input.replace(/\./g, '');
        input = input.replace(',', '.');
        input = input.replace(/[^\d.]/g, '');
        this.mdr[field] = input;
        this.update = true;
    };
    TaxComponent.prototype.sanitizeInputPrice = function (field, value, tag) {
        var input = value.srcElement.value;
        this.update = false;
        input = input.replace('R$', '');
        input = input.replace(' ', '');
        input = input.replace('.', '');
        input = input.replace(',', '.');
        input = input.replace(/[^\d.]/g, '');
        this.price[field] = input;
        this.update = true;
    };
    TaxComponent.prototype.amountCOPQ = function () {
        var _this = this;
        this.sumCOPQ = 0;
        this.COPQs.forEach(function (elem) {
            _this.sumCOPQ += Number(elem.value);
        });
        return (this.sumCOPQ);
    };
    TaxComponent.prototype.amountCA = function () {
        var _this = this;
        this.sumAvoid = 0;
        this.costAvoidances.forEach(function (elem) {
            _this.sumAvoid += Number(elem.value);
        });
        return this.sumAvoid;
    };
    TaxComponent.prototype.saveConveyor = function () {
        this.mdrService.update(this.mdr, this.user).subscribe(function (response) {
            // console.log(response);
        });
    };
    TaxComponent.prototype.savePrice = function () {
        // console.log(this.price);
        this.mdrService.savePrice(this.price, this.mdr).subscribe(function (data) {
            // console.log('teste');
        });
    };
    TaxComponent.prototype.getTotal = function () {
        return this.price.total;
    };
    TaxComponent.prototype.saveUOC = function () {
    };
    TaxComponent.prototype.saveCOPQ = function () {
        var _this = this;
        this.COPQs.forEach(function (copq) {
            _this.mdrService.createCoPQ(copq).subscribe(function (response) {
                // console.log(response);
                _this.mdrService.getCoPQ(_this.mdr).subscribe(function (data) {
                    _this.sumCOPQ = 0;
                    data.forEach(function (elem) {
                        _this.sumCOPQ += Number(elem.value);
                    });
                    _this.COPQs = data;
                });
            });
        });
    };
    TaxComponent.prototype.getAllPriceWithKm = function () {
        var _this = this;
        // console.log(this.mdr);
        this.mdrService.getAllPriceR(this.mdr).subscribe(function (data) {
            // console.log(data);
            _this.price = data;
            _this.mdr.SAD = data.sapCd;
            _this.mdrObservable.changeMDR(_this.mdr);
        });
    };
    TaxComponent.prototype.saveCA = function () {
        var _this = this;
        this.costAvoidances.forEach(function (costAv) {
            _this.mdrService.createCostAvoidance(costAv).subscribe(function (response) {
                // console.log(response);
                _this.mdrService.getCostAvoidance(_this.mdr).subscribe(function (data) {
                    _this.sumAvoid = 0;
                    data.forEach(function (elem) {
                        _this.sumAvoid += Number(elem.value);
                    });
                    _this.costAvoidances = data;
                });
            });
        });
    };
    TaxComponent.prototype.amountUOC = function () {
        var _this = this;
        this.sumUOC = 0;
        this.UOCs.forEach(function (elem) {
            if (elem.status === true) {
                _this.sumUOC += Number(elem.value) * Number(elem['multiplicator']);
            }
        });
        return this.sumUOC;
    };
    TaxComponent.prototype.amountTotal = function () {
        this.sumTotal = Number(this.mdr.valorem) + Number(this.mdr.valorem) + Number(this.mdr.additional);
        if (this.sumTotal > 100000) {
            this.sumTotal = 0;
        }
        return this.sumTotal;
    };
    TaxComponent.prototype.addCOPQ = function () {
        this.COPQs.push(new COPQMDR);
        this.COPQs[this.COPQs.length - 1].idMDR = this.mdr.id;
    };
    TaxComponent.prototype.addCA = function () {
        this.costAvoidances.push(new CostAvoidanceMDR);
        this.costAvoidances[this.costAvoidances.length - 1].idMDR = this.mdr.id;
    };
    TaxComponent.prototype.toggleClass = function () {
        if (this.statusContainer === true) {
            this.statusContainer = false;
        }
        else {
            this.statusContainer = true;
        }
    };
    TaxComponent.prototype.download = function () {
        var json = [];
        json.push({
            0: 'MDR ID',
            1: 'Veiculo',
            2: 'Data de coleta',
            3: 'Total NF subida',
            4: 'KM',
            5: 'Total',
            6: 'Tipo',
            7: 'Obs'
        });
        json.push({
            0: this.mdr.pickupID,
            1: this.mdr.vehicle,
            2: this.dpipe.transform(this.mdr.pickupDate, 'dd/MM/yyyy hh:mm'),
            3: this.cpipe.transform(this.nfePrice, 'BRL'),
            4: this.mdr.totalKM,
            5: this.cpipe.transform(this.price.total, 'BRL'),
            6: 'Frete',
            7: ''
        });
        for (var _i = 0, _a = this.UOCs; _i < _a.length; _i++) {
            var u = _a[_i];
            json.push({
                0: this.mdr.pickupID,
                1: this.mdr.vehicle,
                2: this.dpipe.transform(this.mdr.pickupDate, 'dd/MM/yyyy hh:mm'),
                3: this.cpipe.transform(this.nfePrice, 'BRL'),
                4: this.mdr.totalKM,
                5: this.cpipe.transform(u.value, 'BRL'),
                6: 'UOC',
                7: u.uoc
            });
        }
        var worksheet = XLSX.utils.json_to_sheet(json, {
            skipHeader: true
        });
        var workbook = { Sheets: { 'taxes': worksheet }, SheetNames: ['taxes'] };
        var excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.excel.saveAsExcelFile(excelBuffer, 'taxes');
    };
    return TaxComponent;
}());
export { TaxComponent };
var ConfirmDeleteDialogComponent = /** @class */ (function () {
    function ConfirmDeleteDialogComponent(dialogRef, data, translate) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.translate = translate;
        // console.log(translate);
    }
    ConfirmDeleteDialogComponent.prototype.ngOnInit = function () {
    };
    return ConfirmDeleteDialogComponent;
}());
export { ConfirmDeleteDialogComponent };
var ChooseUsersDialogComponent = /** @class */ (function () {
    function ChooseUsersDialogComponent(dialogRef, data, translate) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.translate = translate;
        this.separatorKeysCodes = [ENTER, COMMA];
        data.ovs = [];
        // console.log(translate);
    }
    ChooseUsersDialogComponent.prototype.add = function (event) {
        console.log(event.value);
        var input = event.input;
        var value = event.value.trim();
        if (value) {
            var duplicate = false;
            for (var _i = 0, _a = this.data.ovs; _i < _a.length; _i++) {
                var ov = _a[_i];
                if (ov.value === value) {
                    duplicate = true;
                    break;
                }
            }
            if (!duplicate) {
                this.data.ovs.push({ value: value, found: true });
            }
        }
        if (input) {
            input.value = '';
        }
    };
    ChooseUsersDialogComponent.prototype.remove = function (ov) {
        var index = this.data.ovs.indexOf(ov);
        if (index >= 0) {
            this.data.ovs.splice(index, 1);
        }
    };
    ChooseUsersDialogComponent.prototype.ngOnInit = function () {
    };
    return ChooseUsersDialogComponent;
}());
export { ChooseUsersDialogComponent };
